import { request } from "../../apis";

export const apiCheckCoupon = (params: any): any =>
  request("get", `/api/coupon/check/${params.coupon_code}`, null, true);
